module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    key: "modal-editar",
    staticClass: "modal is-active"
  }, [_c('div', {
    staticClass: "modal-background",
    on: {
      "click": function($event) {
        return _vm.closeModalAdd()
      }
    }
  }), _c('div', {
    staticClass: "card"
  }, [_c('header', {
    staticClass: "modal-card-head display-flex"
  }, [_c('p', {
    staticClass: "flex-1"
  }, [(_vm.codigo) ? _c('span', [_vm._v("Editar tipo de boleta")]) : _c('span', [_vm._v("Crear tipo de boleta")])]), _c('span', {
    staticClass: "icon cursor-pointer",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])]), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "control margin-bottom-10 flex-1"
  }, [_c('p', {
    staticClass: "margin-bottom-5"
  }, [_vm._v("Código")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.codigo),
      expression: "codigo"
    }],
    staticClass: "input w-90 disabled",
    attrs: {
      "type": "number",
      "disabled": "true"
    },
    domProps: {
      "value": (_vm.codigo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.codigo = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "control margin-bottom-10"
  }, [_c('p', {
    staticClass: "margin-bottom-5"
  }, [_vm._v("Descripcion")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.descripcion),
      expression: "descripcion"
    }],
    staticClass: "input w-300",
    attrs: {
      "type": "text",
      "disabled": _vm.isLoading
    },
    domProps: {
      "value": (_vm.descripcion)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.descripcion = $event.target.value
      }
    }
  })])])]), _c('footer', {
    staticClass: "card-footer"
  }, [_c('a', {
    staticClass: "card-footer-item is-success",
    on: {
      "click": _vm.guardar
    }
  }, [(_vm.isSaving) ? _c('span', [_vm._v("Guardando...")]) : _c('span', [_vm._v("Guardar")])]), _c('a', {
    staticClass: "card-footer-item",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('strong', [_vm._v("Cancelar")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0e1f4f40","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/c_gestion_boletas_tipo_editar.vue
// module id = 749
// module chunks = 0